// apitype
const apitypeList = [
  '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '21', '20', '22', '23', '24']
// 通讯录
const contactsList = [
  {
    contactKey: 'contact',
    name: 'accountName',
    phone: 'accountPhone'
  },
  {
    contactKey: 'vsdfessdd',
    name: 'swerf',
    phone: 'rgthh'
  },
  {
    contactKey: 'fdgdfgf',
    name: 'rter',
    phone: 'ertr'
  },
  {
    contactKey: 'oowerd',
    name: 'adsw',
    phone: 'qeer'
  },
  {
    contactKey: 'uehgbfs',
    name: 'daew',
    phone: 'fvfdv'
  },
  {
    contactKey: 'whjbsaa',
    name: 'qwea',
    phone: 'ewrgf'
  },
  {
    contactKey: 'lhfkj',
    name: 'khkeq',
    phone: 'qhfewiu'
  },
  {
    contactKey: 'khcd',
    name: 'odheuiw',
    phone: 'hvfud'
  },
  {
    contactKey: 'dfted',
    name: 'fgde',
    phone: 'gtyt'
  },
  {
    contactKey: 'sdswfre',
    name: 'dsfge',
    phone: 'werf'
  },
  {
    contactKey: 'ienvjs',
    name: 'knhdjhe',
    phone: 'nbfyew'
  },
  {
    contactKey: 'ldnvjk',
    name: 'mbvheiw',
    phone: 'tjcjkds'
  },
  {
    contactKey: 'uiyuiyhgv',
    name: 'fghbfbd',
    phone: 'ertert'
  },
  {
    contactKey: 'dfgethrth',
    name: 'ddfgh',
    phone: 'dfbfdg'
  },
  {
    contactKey: 'dfghrtdf',
    name: 'sdfwesdf',
    phone: 'sdthhrt'
  },
  {
    contactKey: 'jnhgd',
    name: 'rgfsfg',
    phone: 'rtbgfh'
  },
  {
    contactKey: 'atxcypcpspq',
    name: 'rwauqyfvdb',
    phone: 'sohyvqzxx'
  },
  {
    contactKey: 'mhzdijm',
    name: 'gtto',
    phone: 'qmnnrt'
  },
  {
    contactKey: 'anawzmvdfht',
    name: 'xbsf',
    phone: 'xeetcnzb'
  },
  {
    contactKey: 'kaxcke',
    name: 'mupf',
    phone: 'iiroryjw'
  },
  {
    contactKey: 'hiibulogjw',
    name: 'zqychhwwo',
    phone: 'ejgbz'
  },
  {
    contactKey: 'laowijme',
    name: 'elbgzglnnu',
    phone: 'irhslzhs'
  },
  {
    contactKey: 'azfsf',
    name: 'toekrseuwe',
    phone: 'ynnmxdp'
  },
  {
    contactKey: 'xhlyrewn',
    name: 'glmxarubu',
    phone: 'pgdaxh'
  },
  {
    contactKey: 'vvoynjottc',
    name: 'gxrqtiob',
    phone: 'bwdnsr'
  },
  {
    contactKey: 'pumeazqscfh',
    name: 'wfjoi',
    phone: 'doxvypp'
  }

]
// 好评弹框方法
const scoreFuncNameList = [
  'udhajs',
  'hcddf',
  'fgtrr',
  'oueiwv',
  'ubhss',
  'iiiervz',
  'wsewer',
  'owhfuisg',
  'cbbhvi',
  'fujyturt',
  'Jfsekogkl',
  'dfhthydd',
  'rnfsghs',
  'qhvcbbi',
  'jwkswlh',
  'yhxnpwxd',
  'lpfy',
  'vohwdaxivou',
  'mzdbmbbexnke',
  'bhjy',
  'gyejftdaiz',
  'ocuzqoa',
  'lvqddlij'
]
export { contactsList, scoreFuncNameList, apitypeList }
